import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import { palette } from '../../../../../../../settings/themes/colors';

const useStyles = makeStyles({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  cardContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    color: palette.dimGray,
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    lineHeight: 1.3,
    minHeight: 34
  },
  value: {
    color: palette.captudataBlue,
    fontFamily: 'Nunito',
    fontSize: 36,
    fontWeight: 900,
    lineHeight: 1.1,
    marginTop: 'auto'
  },
  unit: {
    fontSize: 22,
    fontWeight: 700,
    marginLeft: 4
  }
});

export const StatWidget = ({ widget }) => {
  const classes = useStyles();
  const { title, data } = widget;
  const value = data ? data.value : null;
  const unit = data ? data.unit : null;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.value}>
          {value != null ? value : '—'}
          {unit ? <span className={classes.unit}>{unit}</span> : null}
        </Typography>
      </CardContent>
    </Card>
  );
};

StatWidget.propTypes = {
  widget: PropTypes.shape({
    title: PropTypes.string,
    data: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      unit: PropTypes.string
    })
  }).isRequired
};
